$.validator.addMethod('personnummer', function (value) {
    if (!value) {
        return true;
    }

    value = value.trim();

    // Bara siffror och + eller - �r till�tna
    value = value.replace('-', '');
    value = value.replace('+', '');

    if (/^\d+$/.test(value) === false) {
        return false;
    }

    value = value
        .replace(/\D/g, '') // Strip out all but digits
        .split('') // Convert string to array
        .reverse() // Reverse order for Luhn
        .slice(0, 10); // Keep only 10 digits (i.e. 1977 becomes 77)

    // verify we got 10 digits, otherwise it is invalid
    if (value.length !== 10) {
        return false;
    }

    var sum = value
        // Convert to number
        .map(function (n) {
            return Number(n);
        })
        // Perform arithmetic and return sum
        .reduce(function (previous, current, index) {
            // Multiply every other number with two
            if (index % 2) {
                current *= 2;
            }
            // If larger than 10 get sum of individual digits (also n-9)
            if (current > 9) {
                current -= 9;
            }
            // Sum it up
            return previous + current;
        });

    // Sum must be divisible by 10
    return sum % 10 === 0;
});
$.validator.unobtrusive.adapters.addBool('personnummer');
